i<script>
	// Stores 
	import { 
		textSite,
		linkPesquisaVendas,
		linkPesquisaLocacao,

	} from '../store.js';  

	// Componentes
	import PageHeader                       from './../components/PageHeader.svelte';
	import { Router, Link, link , Route }   from "svelte-routing";
	import { fade, fly }                    from 'svelte/transition';
	import { quintOut }                     from 'svelte/easing';    

	// Code
	let titlePage = 'Política de privacidade';
</script>

<section class="conteudo-internas">
	<PageHeader title={titlePage}></PageHeader>
	<div class="container clearfix text-justify mb-50">
		<p>Valorizamos a sua confiança e queremos garantir que sua experiência conosco seja transparente e segura. Antes de prosseguir, convidamos você a conhecer nossa política de privacidade. Este documento detalha como coletamos, usamos e protegemos suas informações pessoais, garantindo sua privacidade e segurança em cada interação conosco. Clique no botão abaixo para acessar nossa política de privacidade e entender melhor como estamos comprometidos em proteger seus dados.</p>
		<a class="btn btn-primary" href="https://www.dinmar.com.br/privacidade" target="_blank">Acesse aqui a Política de privacidade</a>
	</div>
</section>